module.exports = __webpack_public_path__ + "static/media/uoa-11.8d7e7251.jpg";